import React from "react";
import { motion } from "framer-motion";

const About = () => {
  return (
    <section
      id="about"
      className="relative px-5 md:px-10 py-20 md:py-28 border-b-4 border-[#1C1914] bg-[#FDE047]"
      data-testid="about-section"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <p className="font-condensed text-lg uppercase tracking-widest text-[#4A5D23]" data-testid="about-eyebrow">
            // Our story, allegedly
          </p>
          <h2 className="font-display text-5xl md:text-7xl uppercase leading-none mt-3" data-testid="about-title">
            When life gave us lemons, we drew them.
          </h2>
        </div>

        <div className="lg:col-span-7 space-y-6 font-body text-lg md:text-xl leading-relaxed">
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            data-testid="about-paragraph-1"
          >
            DUDS started as a list of bad ideas on the back of a parking ticket. It is, in many ways, still that list.
            We make tee shirts featuring cartoon lemons doing things they're not qualified to do — racing NASCAR,
            launching motocross bikes off cliffs, founding small clothing brands.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            data-testid="about-paragraph-2"
          >
            Every shirt is <span className="bg-[#1C1914] text-[#FFFDF5] px-2 py-0.5">heavyweight cotton</span>,
            screen printed in small batches, and shipped with at least one
            <span className="bg-[#D95D39] text-[#FFFDF5] px-2 py-0.5 mx-1">spelling mistake</span>
            on the receipt. We consider this a feature.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            data-testid="about-paragraph-3"
          >
            If a shirt is funny, we print it. If it isn't, we usually print it anyway. The bar is in hell and we are
            committed to maintaining its location.
          </motion.p>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="pt-6 grid grid-cols-3 gap-4 max-w-xl"
            data-testid="about-stats"
          >
            <div className="border-2 border-[#1C1914] bg-[#FFFDF5] p-4">
              <div className="font-display text-4xl md:text-5xl leading-none">05</div>
              <div className="font-condensed text-sm uppercase tracking-widest mt-1">designs in drop 001</div>
            </div>
            <div className="border-2 border-[#1C1914] bg-[#FFFDF5] p-4">
              <div className="font-display text-4xl md:text-5xl leading-none">100%</div>
              <div className="font-condensed text-sm uppercase tracking-widest mt-1">unsolicited opinions</div>
            </div>
            <div className="border-2 border-[#1C1914] bg-[#FFFDF5] p-4">
              <div className="font-display text-4xl md:text-5xl leading-none">∞</div>
              <div className="font-condensed text-sm uppercase tracking-widest mt-1">excuses for the delay</div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
